import { ArrowRight, MapPin } from "lucide-react";
import { Button } from "../components/ui/button";
import { BUSINESS } from "../lib/site";

const HERO_IMG =
  "https://images.pexels.com/photos/6636500/pexels-photo-6636500.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1080&w=1920";

export default function Hero() {
  return (
    <section className="relative min-h-screen pt-16 overflow-hidden" data-testid="hero-section">
      {/* Background image with overlays */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Macro motherboard"
          className="absolute inset-0 w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/85 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#0A0A0A]" />
        <div className="absolute inset-0 grid-bg opacity-50" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 pt-24 sm:pt-32 lg:pt-40 pb-20">
        <div className="max-w-3xl">
          {/* Status pill */}
          <div className="inline-flex items-center gap-2 mb-8 font-mono text-[10px] tracking-[0.25em] uppercase text-[#34C759]">
            <span className="relative flex w-2 h-2">
              <span className="absolute inline-flex w-full h-full rounded-full bg-[#34C759] opacity-75 animate-ping" />
              <span className="relative inline-flex w-2 h-2 rounded-full bg-[#34C759]" />
            </span>
            <span data-testid="hero-status">Accepting repairs · Susquehanna, PA</span>
          </div>

          {/* Heading */}
          <h1
            className="font-display font-bold text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.95] mb-8"
            data-testid="hero-heading"
          >
            Console &amp; PC repair,
            <br />
            <span className="text-zinc-500">done</span>{" "}
            <span className="text-[#0055FF]">right.</span>
          </h1>

          <p className="text-lg sm:text-xl text-zinc-400 max-w-xl leading-relaxed mb-10" data-testid="hero-subhead">
            Dust-clogged fans, dead controllers, swapped SSDs, cracked laptop screens. Drop your device
            off in person or ship it in — I diagnose it, fix it, and get you back online.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <a href="#booking" data-testid="hero-book-button">
              <Button
                size="lg"
                className="bg-[#0055FF] hover:bg-blue-600 text-white rounded-md font-semibold px-8 py-6 text-base group"
              >
                Book a Repair
                <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </Button>
            </a>
            <a href="#track" data-testid="hero-track-button">
              <Button
                variant="outline"
                size="lg"
                className="bg-transparent border-zinc-700 text-white hover:bg-white/5 hover:text-white rounded-md font-semibold px-8 py-6 text-base"
              >
                Track existing ticket
              </Button>
            </a>
          </div>

          {/* Footer info row */}
          <div className="flex flex-wrap gap-8 font-mono text-xs tracking-[0.15em] uppercase text-zinc-500">
            <div className="flex items-center gap-2">
              <MapPin className="w-3 h-3 text-[#0055FF]" />
              <span>{BUSINESS.address}</span>
            </div>
            <div>
              <span className="text-zinc-600">CALL · </span>
              <a href={BUSINESS.phoneHref} className="text-zinc-300 hover:text-white">
                {BUSINESS.phone}
              </a>
            </div>
            <div>
              <span className="text-zinc-600">HRS · </span>SAT NIGHT · ALL DAY SUN
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
